import { LINKS } from "../../lib/links";
import { ArrowUpRight } from "lucide-react";

export const Application = () => {
  return (
    <section
      id="apply"
      data-testid="application-section"
      className="relative bg-[#050505] py-24 md:py-40 border-t border-zinc-900"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12 md:mb-16">
          <div className="reveal flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-10 bg-zinc-600" />
            <span className="text-xs tracking-[0.3em] uppercase text-zinc-400 font-bold">
              Application Only
            </span>
            <span className="h-px w-10 bg-zinc-600" />
          </div>
          <h2
            data-testid="application-headline"
            className="reveal text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-extrabold text-white leading-[1.02]"
          >
            Apply to The <br />
            <span className="italic font-light text-zinc-300">
              Builder Programme.
            </span>
          </h2>
          <p
            data-testid="application-subheadline"
            className="reveal mt-6 max-w-2xl mx-auto text-base md:text-lg leading-relaxed text-zinc-400 font-medium"
          >
            Complete the application below. Successful applicants will be
            contacted directly with next steps.
          </p>
        </div>

        {/* Embedded Google Form */}
        <div
          data-testid="application-form-wrap"
          className="reveal relative bg-[#0A0A0A] border border-zinc-900 p-2 md:p-3"
        >
          <div className="absolute -top-3 left-6 bg-[#050505] px-3 text-[10px] tracking-[0.3em] uppercase text-zinc-500 font-bold">
            Builder Programme · Application
          </div>
          <div className="relative w-full h-[560px] md:h-[720px] overflow-hidden bg-[#0A0A0A]">
            {LINKS.googleFormEmbed.includes("PLACEHOLDER") ? (
              <div
                data-testid="application-form-placeholder"
                className="absolute inset-0 flex flex-col items-center justify-center text-center px-8"
              >
                <div className="border border-zinc-800 px-6 py-2 text-[10px] tracking-[0.3em] uppercase text-zinc-500 font-bold mb-8">
                  Form Placeholder
                </div>
                <h3 className="text-2xl md:text-3xl tracking-tight font-bold text-white mb-4 leading-tight max-w-xl">
                  The application form will be embedded here.
                </h3>
                <p className="text-sm md:text-base text-zinc-500 max-w-md leading-relaxed mb-8">
                  Once Jordan's Google Form is ready, paste the embed URL into{" "}
                  <code className="text-zinc-300">/src/lib/links.js</code> and
                  it will appear right inside this frame — fully styled.
                </p>
                <a
                  href="#apply"
                  data-testid="application-placeholder-cta"
                  className="inline-flex items-center gap-3 text-white border border-zinc-700 hover:border-white transition-colors px-6 py-3"
                >
                  <span className="text-xs tracking-[0.25em] uppercase font-bold">
                    Email Jordan Directly
                  </span>
                </a>
              </div>
            ) : (
              <iframe
                data-testid="application-form-iframe"
                src={LINKS.googleFormEmbed}
                title="Builder Programme Application"
                className="w-full h-full border-0 bg-white"
                loading="lazy"
              >
                Loading…
              </iframe>
            )}
          </div>

          {/* Fallback button if iframe blocked — hidden while form is still a placeholder */}
          {!LINKS.googleFormEmbed.includes("PLACEHOLDER") && (
            <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-4 border-t border-zinc-900">
              <p className="text-xs tracking-[0.2em] uppercase text-zinc-500 font-bold">
                Trouble loading the form?
              </p>
              <a
                href={LINKS.googleFormEmbed}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="application-external-link"
                className="group inline-flex items-center gap-3 text-white border-b border-zinc-700 hover:border-white transition-colors pb-1"
              >
                <span className="text-xs tracking-[0.25em] uppercase font-bold">
                  Open application in new tab
                </span>
                <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </a>
            </div>
          )}
        </div>

        <p className="reveal mt-10 text-center text-sm text-zinc-500 max-w-xl mx-auto">
          This programme is application-only and designed for serious people
          ready to execute.
        </p>
      </div>
    </section>
  );
};
